module.exports = __webpack_public_path__ + "img/placeholder.9deb3af4.jpg";